import React from 'react';
import PropTypes from 'prop-types';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const ErrorSnakbar = ({
	handleSnackBarClose,
	message,
	severity,
	showAlert,
}) => {
	return (
		<Snackbar
			open={showAlert}
			autoHideDuration={4000}
			onClose={handleSnackBarClose()}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
		>
			<Alert
				onClose={handleSnackBarClose()}
				severity={severity}
				sx={{ width: '100%' }}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

ErrorSnakbar.propTypes = {
	handleSnackBarClose: PropTypes.func,
	message: PropTypes.string,
	data: PropTypes.object,
	showAlert: PropTypes.bool,
};
